import * as fromDatatype from "../../../../models/datatype-library";

export class StatementOfAccountRunHdrSearchCriteriaDtoModel {
    guids?: any [];
    batch_running_no?: string;
    run_type?: string;
    run_status?: string;
    statement_type?: string;
    printable_format_hdr_guid?: string;
    stmt_start_date?: fromDatatype.TimestampTzDatatypeInterface;
    stmt_end_date?: fromDatatype.TimestampTzDatatypeInterface;
    soa_settings_json?: fromDatatype.JsonDatatypeInterface;
    companies_json?: fromDatatype.JsonDatatypeInterface;
    recipient_emails?: fromDatatype.JsonDatatypeInterface;
    customer_categories?: fromDatatype.JsonDatatypeInterface;
    run_by_guid?: fromDatatype.GuidDataFieldInterface;
    run_start_date?: fromDatatype.TimestampTzDatatypeInterface;
    run_end_date?: fromDatatype.TimestampTzDatatypeInterface;
    created_date?: fromDatatype.TimestampTzDatatypeInterface;
    updated_date?: fromDatatype.TimestampTzDatatypeInterface;
    search_word?: string;
  }
  